import styled, { keyframes } from "styled-components";

export const LoaderContainer = styled.div`
    display: inline-flex;
    align-items: center;
    padding: 10%;
`;

export const spin = keyframes`
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
`;

export const RotatingLoader = styled.div`
    margin: auto;
    width: 100px;
    height: 100px;
    animation: ${spin} 0.75s infinite linear;
    position: absolute;
    bottom: 0px;
    left: 0px;
    right: 0px;
    top: 0px;
    z-index: 999;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 100%;
    border: 12px solid mix(rgb(57, 184, 18), white, 20%);
    border-right-color: rgb(57, 184, 18);
`;
